import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHarbour = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3929_33936)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6 6H18V9.96L12 8L6 9.96V6ZM3.94 19H4C5.6 19 7 18.12 8 17C9 18.12 10.4 19 12 19C13.6 19 15 18.12 16 17C17 18.12 18.4 19 20 19H20.05L21.95 12.31C22.03 12.06 22 11.78 21.89 11.54C21.76 11.3 21.55 11.12 21.29 11.04L20 10.62V6C20 4.89 19.1 4 18 4H15V1H9V4H6C4.9 4 4 4.9 4 6V10.62L2.71 11.04C2.45 11.12 2.24 11.3 2.11 11.54C2 11.78 1.97 12.06 2.05 12.31L3.94 19ZM20 21C18.61 21 17.22 20.53 16 19.67C13.56 21.38 10.44 21.38 8 19.67C6.78 20.53 5.39 21 4 21H2V23H4C5.37 23 6.74 22.65 8 22C10.5 23.3 13.5 23.3 16 22C17.26 22.65 18.62 23 20 23H22V21H20Z",
			fill: "#C6CDD2"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3929_33936",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 22,
			fill: "white",
			transform: "translate(2 1)"
		})
	}) })]
});
export default SvgHarbour;
